import React from 'react'

const withRemoteSort = Component =>
	class SearchWrap extends React.Component {
		constructor(props) {
			super(props)
			const { defaultSorted = [] } = this.props
			this.state = {
				sort: defaultSorted.map(({ id, desc }) => ({ field: id, order: desc ? 'DESC' : 'ASC' }))
			}
		}

		setSort = ([{ id, desc }]) => {
			// this is for multisort
			// let newSortArr = this.state.sort.filter(({ field }) => field !== id)
			// newSortArr.push({ field: id, order: desc ? 'DESC' : 'ASC' })
			// console.log(newSortArr)
			// this.setState({ sort: newSortArr })

			this.setState({ sort: [{
				field: id,
				order: desc ? 'DESC' : 'ASC'
			}] })
		}

		render() {
			return(
				<Component
					{...this.props}
					manual
					sortable
  				// multiSort
  				remoteSort={this.state.sort}
					onSortedChange={this.setSort}
				/>
			)
		}
	}

export default withRemoteSort
